import {Localizer} from "../../../infrastructure/localization/localizer";

export enum UddannelseTypeEnum {
    KBU = 1,
    Introduktion = 2,
    Hoveduddannelse = 3
}

export function GetUddannelsestypeTranslation(type?: UddannelseTypeEnum, entireKbuString: boolean = false) {
    switch (type) {
        case UddannelseTypeEnum.KBU:
            return entireKbuString ? Localizer.global_kliniskBasisuddannelse() : Localizer.global_KBU();
        case UddannelseTypeEnum.Introduktion:
            return Localizer.global_introduktion();
        case UddannelseTypeEnum.Hoveduddannelse:
            return Localizer.global_hoveduddannelse();
        default:
            return "";
    }
}

export function GetUddannelsestypeFromIdTranslation(id: string, abbreviatedKbuName?: boolean, abbreviatedIntroName?: boolean, abbreviatedHuName?: boolean) {
    switch (id.toUpperCase()) {
        case "3ABC3B00-E8AD-4473-9F61-AC35752039F9":
            return abbreviatedKbuName
                ? Localizer.global_KBU()
                : Localizer.global_kliniskBasisuddannelse();
        case "5C162F19-D8DF-4306-884D-B393EE628C5C":
            return abbreviatedIntroName
                ? Localizer.global_intro()
                : Localizer.global_introduktion()
        case "65A715A9-9BA4-48F5-99F5-57722AF02C41":
            return abbreviatedHuName
                ? Localizer.global_HU()
                : Localizer.global_hoveduddannelse();
        default:
            return "";
    }
}
